export default __webpack_public_path__ + "static/media/7.729b71c0.jpg";